import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class GetOrderInvoiceDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.INVOICE
		this.url = '/invoice/getOrderInvoiceDetail'
		this.desc = '根据订单号获取订单发票信息接口'
	}
}

export class SendOrderInvoiceToMail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.INVOICE
		this.url = '/invoice/sendOrderInvoiceToMail'
		this.desc = '发票重新发送邮件'
	}
}

export class GetOrderInvoicePdfUrl extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.INVOICE
		this.url = '/invoice/getOrderInvoicePdfUrl'
		this.desc = '根据订单号获取订单发票地址信息接口'
	}
}
